"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _validateEnvironment = require("./validateEnvironment");
Object.keys(_validateEnvironment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _validateEnvironment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateEnvironment[key];
    }
  });
});
var _validateInteger = require("./validateInteger");
Object.keys(_validateInteger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _validateInteger[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateInteger[key];
    }
  });
});
var _validateLanguage = require("./validateLanguage");
Object.keys(_validateLanguage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _validateLanguage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateLanguage[key];
    }
  });
});
var _validateLanguageCode = require("./validateLanguageCode");
Object.keys(_validateLanguageCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _validateLanguageCode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateLanguageCode[key];
    }
  });
});
var _validatePortNumber = require("./validatePortNumber");
Object.keys(_validatePortNumber).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _validatePortNumber[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validatePortNumber[key];
    }
  });
});
var _validateTenant = require("./validateTenant");
Object.keys(_validateTenant).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _validateTenant[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateTenant[key];
    }
  });
});
